export default (itemUser, currentUser) => {
  if (itemUser.id === currentUser.id) return "#1e62d8";
  return null;
};
